import {BottomBarFeatures} from './BottomBarFeatures';

export enum AsgardFeatureNames {
  NEW_TAB = 'NEW_TAB',
  OPEN_DOC = 'OPEN_DOC',
  OPEN_DRIVE = 'OPEN_DRIVE',
  OPEN_DODP = 'OPEN_DODP',
  OPEN_STI = 'OPEN_STI',
  SAVE_TO_DRIVE = 'SAVE_TO_DRIVE',
  SAVE_AS_TO_DRIVE = 'SAVE_TO_DRIVE',
  SAVE = 'SAVE',
  DOWNLOAD = 'DOWNLOAD',
  IMPORT_KES = 'IMPORT_KES',
  EXPORT_KES = 'EXPORT_KES',
  IMPORT_KES_DRIVE = 'IMPORT_KES_DRIVE',
  EXPORT_KES_DRIVE = 'EXPORT_KES_DRIVE',
  PRINT = 'PRINT',
  OCR_ON_FILE = 'OCR_ON_FILE',
  SCAN_OCR_DRIVE = 'SCAN_OCR_DRIVE',
  SCAN_OCR_OPENFILE = 'SCAN_OCR_OPENFILE',
  OCR_START = 'OCR_START',
  SCANNER_ADD_PAGE = 'SCANNER_ADD_PAGE',
  SCANNER_SETUP = 'SCANNER_SETUP',
  DELETE_PAGE = 'DELETE_PAGE',
  ADD_PAGE = 'ADD_PAGE',
  MOVE_PAGE_UP = 'MOVE_PAGE_UP',
  MOVE_PAGE_DOWN = 'MOVE_PAGE_DOWN',
  PAGE_NUMBERING = 'PAGE_NUMBERING',
  AUDIO_FILES = 'AUDIO_FILES',
  SEARCH = 'SEARCH',
  AUDIO_MAKER = 'AUDIO_MAKER',
  SCREENSHOT_READER = 'SCREENSHOT_READER',
  WORD_PREDICTION = 'WORD_PREDICTION',
  WORD_PREDICTION_DIALOG = 'WORD_PREDICTION_DIALOG',
  WORD_PREDICTION_SPLIT_AREA = 'WORD_PREDICTION_SPLIT_AREA',
  SPELL_CHECK = 'SPELL_CHECK',
  SPEACH_RECOGNITION = 'SPEACH_RECOGNITION',
  PRONUNCIATION = 'PRONUNCIATION',
  CORRECTION_LIST = 'CORRECTION_LIST',
  TOOLBAR_MENU = 'TOOLBAR_MENU',
  MARKUP_MENU = 'MARKUP_MENU',
  HIGHLIGHT_MENU = 'HIGHLIGHT_MENU',
  EPUB_MENU = 'EPUB_MENU',
  PREV_READ_UNIT = 'PREV_READ_UNIT',
  START_READ_UNIT = 'START_READ_UNIT',
  STOP_READ_UNIT = 'STOP_READ_UNIT',
  NEXT_READ_UNIT = 'NEXT_READ_UNIT',
  DRAWING_TOOLS = 'DRAWING_TOOLS',
  LOOK_UP = 'LOOK_UP',
  TRANSLATE = 'TRANSLATE',
  SETTINGS = 'SETTINGS',
  ABOUT_MENU = 'ABOUT_MENU',
  GENERAL = 'GENERAL',
  SPEECH = 'SPEECH',
  NAVIGATION = 'NAVIGATION',
  SPELL_CHECKER_SETTINGS = 'SPELL_CHECKER_SETTINGS',
  WORD_PREDICTION_SETTINGS = 'WORD_PREDICTION_SETTINGS',
  ZONES = 'ZONES',
  STORAGE = 'STORAGE',
  LAYOUT = 'LAYOUT',
  DRAWING = 'DRAWING',
  ABOUT = 'ABOUT',
  CLOUD_SETTINGS = 'CLOUD_SETTINGS',
  SIGN_OUT = 'SIGN_OUT',
  DROP_DOWN_MENUS = 'DROP_DOWN_MENUS',
  TOGGLE_BOTTOM_BAR = 'TOGGLE_BOTTOM_BAR',
  TEXT_NOTES = 'TEXT_NOTES',
  MARKERS = 'MARKERS',
  TEXT_STYLING_MENU = 'TEXT_STYLING_MENU',
  STICKY_NOTES = 'STICKY_NOTES',
  SHOW_TEXT_ANNOTATIONS = 'SHOW_TEXT_ANNOTATIONS',
  SHOW_STICKY_ANNOTATIONS = 'SHOW_STICKY_ANNOTATIONS',
  CLOSE_DOCUMENT = 'CLOSE_DOCUMENT',
  TEXT_NOTE_STYLE = 'TEXT_NOTE_STYLE',
  SPEECH_RECOGNITION = 'SPEECH_RECOGNITION',
  READER_LAYOUT = 'READER_LAYOUT',
  SELECT_TAB = 'SELECT_TAB',
  FEATURE_RESTRICTIONS = 'FEATURE_RESTRICTIONS',
  DICTIONARY = 'DICTIONARY',
  IMAGE_DICTIONARY = 'IMAGE_DICTIONARY',
  CONJUGATIONS = 'CONJUGATIONS',
  COLLAPSED_FEATURES_MENU = 'COLLAPSED_FEATURES_MENU',
  MAINMENUFILES = 'MAINMENUFILES',
  MAINMENUOCR = 'MAINMENUOCR',
  MAINMENUTOOLS = 'MAINMENUTOOLS',
  DRAW_RECT = 'DRAW_RECT',
  DRAW_CIRCLE = 'DRAW_CIRCLE',
  DRAW_ARROW = 'DRAW_ARROW',
  DRAW_STR_LINE = 'DRAW_STR_LINE',
  DRAW_LINE = 'DRAW_LINE',
  DELETE_EMPTY_TEXT_NOTES = 'DELETE_EMPTY_TEXT_NOTES',
  NOTE_CREATION_MODE_SINGLE = 'NOTE_CREATION_MODE_SINGLE',
  NOTE_CREATION_MODE_MULTI = 'NOTE_CREATION_MODE_MULTI',
  EXAM_MODE_WINDOW = 'EXAM_MODE_WINDOW',
  EXAM_MODE_FLOATING_TOOLBAR = 'EXAM_MODE_FLOATING_TOOLBAR',
  EXAM_CREATION_FLOATING_TOOLBAR = 'EXAM_CREATION_FLOATING_TOOLBAR',
}


export interface ICompretitiveFeature {
  feature: AsgardFeatureNames | BottomBarFeatures;
  competitiveActiveList: AsgardFeatureNames[] | BottomBarFeatures[];
  competitiveUnActiveList: AsgardFeatureNames[] | BottomBarFeatures[];
}

export const floatingMenuList: AsgardFeatureNames[] = [
  AsgardFeatureNames.SEARCH,
  AsgardFeatureNames.DRAWING_TOOLS,
  AsgardFeatureNames.SPEECH_RECOGNITION,
  AsgardFeatureNames.HIGHLIGHT_MENU,
  AsgardFeatureNames.MARKUP_MENU,
  AsgardFeatureNames.TOOLBAR_MENU
];

export const competitiveList: ICompretitiveFeature[] = [
  {
    feature: AsgardFeatureNames.TEXT_NOTES,
    competitiveActiveList: [
      AsgardFeatureNames.DRAWING,
      AsgardFeatureNames.MARKERS,
      AsgardFeatureNames.STICKY_NOTES,
    ],
    competitiveUnActiveList: []
  },
  {
    feature: AsgardFeatureNames.STICKY_NOTES,
    competitiveActiveList: [
      AsgardFeatureNames.DRAWING,
      AsgardFeatureNames.MARKERS,
      AsgardFeatureNames.TEXT_NOTES,
    ],
    competitiveUnActiveList: []
  },
  {
    feature: AsgardFeatureNames.DRAWING,
    competitiveActiveList: [
      AsgardFeatureNames.TEXT_NOTES,
      AsgardFeatureNames.STICKY_NOTES,
      AsgardFeatureNames.MARKERS,
    ],
    competitiveUnActiveList: []
  },
  {
    feature: AsgardFeatureNames.MARKERS,
    competitiveActiveList: [
      AsgardFeatureNames.TEXT_NOTES,
      AsgardFeatureNames.STICKY_NOTES,
      AsgardFeatureNames.DRAWING,
    ],
    competitiveUnActiveList: []
  },
  {
    feature: AsgardFeatureNames.WORD_PREDICTION,
    competitiveActiveList: [
      // AsgardFeatureNames.AUDIO_MAKER
    ],
    competitiveUnActiveList: [
      AsgardFeatureNames.WORD_PREDICTION_DIALOG,
      AsgardFeatureNames.WORD_PREDICTION_SPLIT_AREA
    ]
  },
  {
    feature: AsgardFeatureNames.DRAWING_TOOLS,
    competitiveActiveList: [
      // AsgardFeatureNames.AUDIO_MAKER,
    ],
    competitiveUnActiveList: [
      AsgardFeatureNames.DRAWING,
    ]
  },
  {
    feature: AsgardFeatureNames.HIGHLIGHT_MENU,
    competitiveActiveList: [
      AsgardFeatureNames.AUDIO_MAKER,
    ],
    competitiveUnActiveList: [
      AsgardFeatureNames.MARKERS,
    ]
  },
  {
    feature: AsgardFeatureNames.TOOLBAR_MENU,
    competitiveActiveList: [
      AsgardFeatureNames.AUDIO_MAKER,
    ],
    competitiveUnActiveList: [
      AsgardFeatureNames.TEXT_NOTES,
      AsgardFeatureNames.STICKY_NOTES,
    ]
  },
  {
    feature: AsgardFeatureNames.MARKUP_MENU,
    competitiveActiveList: [
      AsgardFeatureNames.AUDIO_MAKER,
    ],
    competitiveUnActiveList: []
  },
  {
    feature: AsgardFeatureNames.AUDIO_MAKER,
    competitiveActiveList: [
      AsgardFeatureNames.TOOLBAR_MENU,
      AsgardFeatureNames.DRAWING_TOOLS,
      AsgardFeatureNames.HIGHLIGHT_MENU,
      AsgardFeatureNames.MARKUP_MENU,
      AsgardFeatureNames.SCREENSHOT_READER,
    ],
    competitiveUnActiveList: []
  },
  {
    feature: AsgardFeatureNames.NOTE_CREATION_MODE_SINGLE,
    competitiveActiveList: [
      AsgardFeatureNames.NOTE_CREATION_MODE_MULTI,
    ],
    competitiveUnActiveList: []
  },
  {
    feature: AsgardFeatureNames.NOTE_CREATION_MODE_MULTI,
    competitiveActiveList: [
      AsgardFeatureNames.NOTE_CREATION_MODE_SINGLE,
    ],
    competitiveUnActiveList: []
  }
];

const icons = new Map<AsgardFeatureNames, string>([
  [AsgardFeatureNames.NEW_TAB, 'fas fa-file'],
  [AsgardFeatureNames.OPEN_DRIVE, 'fab fa-google-drive'],
  [AsgardFeatureNames.OPEN_DODP, 'fas fa-folder-open'],
  [AsgardFeatureNames.SAVE_TO_DRIVE, 'fab fa-google-drive'],
  [AsgardFeatureNames.SAVE_AS_TO_DRIVE, 'fab fa-google-drive'],
  [AsgardFeatureNames.DOWNLOAD, 'fas fa-save'],
  [AsgardFeatureNames.EXPORT_KES, 'fas fa-file-upload'],
  [AsgardFeatureNames.EXPORT_KES_DRIVE, 'fab fa-google-drive'],
  [AsgardFeatureNames.PRINT, 'fas fa-print'],
  [AsgardFeatureNames.OCR_ON_FILE, 'fas fa-file'],
  [AsgardFeatureNames.SCAN_OCR_DRIVE, 'fab fa-google-drive'],
  [AsgardFeatureNames.SCAN_OCR_OPENFILE, 'fab fa-google-drive'],
  [AsgardFeatureNames.SEARCH, 'fas fa-search'],
  [AsgardFeatureNames.AUDIO_MAKER, 'icon-mp3'],
  [AsgardFeatureNames.SCREENSHOT_READER, 'fas fa-camera'],
  [AsgardFeatureNames.WORD_PREDICTION, 'fas fa-hat-wizard'],
  [AsgardFeatureNames.SPELL_CHECK, 'far fa-spell-check'],
  [AsgardFeatureNames.TOOLBAR_MENU, 'fas fa-comment-alt-edit'],
  [AsgardFeatureNames.MARKUP_MENU, 'fas fa-mouse-pointer'],
  [AsgardFeatureNames.HIGHLIGHT_MENU, 'fas fa-highlighter'],
  [AsgardFeatureNames.EPUB_MENU, 'fas fa-comment'],
  [AsgardFeatureNames.DRAWING_TOOLS, 'fas fa-draw-square'],
  [AsgardFeatureNames.LOOK_UP, 'fas fa-book-open'],
  [AsgardFeatureNames.TRANSLATE, 'far fa-language'],
  [AsgardFeatureNames.SETTINGS, 'fas fa-cog'],
  [AsgardFeatureNames.SPEECH, 'fas fa-play'],
  [AsgardFeatureNames.SIGN_OUT, 'fas fa-sign-out'],
  [AsgardFeatureNames.CLOSE_DOCUMENT, 'fas fa-times-circle'],
  [AsgardFeatureNames.SPEECH_RECOGNITION, 'fas fa-microphone-alt'],
  [AsgardFeatureNames.DICTIONARY, 'fas fa-book-open'],
  [AsgardFeatureNames.IMAGE_DICTIONARY, 'fas fa-book-open'],
  [AsgardFeatureNames.CONJUGATIONS, 'fas fa-book-open'],
  [AsgardFeatureNames.MAINMENUFILES, 'fas fa-file'],
  [AsgardFeatureNames.MAINMENUOCR, 'fas fa-text'],
  [AsgardFeatureNames.MAINMENUTOOLS, 'fas fa-tools'],
  [AsgardFeatureNames.EXAM_MODE_WINDOW, 'fas fa-graduation-cap']
]);

export const featureIcons = icons as ReadonlyMap<AsgardFeatureNames, string>;
